module.exports = __webpack_public_path__ + "static/media/Dashboard-icon.b2f78ef4.svg";